import type { RouteRecordRaw } from 'vue-router';
import { useFeatures } from '@/composables/useFeatures';

// The connect API answers 404 without this flag, so users who lack it skip the
// step the same way the dashboard hides its Meetings section.
const requireMeetingRecorder = () => {
  const { getFeature } = useFeatures();
  if (!getFeature('calendar-meeting-recorder', false).value) {
    return { name: 'download' };
  }

  return true;
};

export const routes: RouteRecordRaw[] = [
  {
    name: 'profile',
    path: 'profile',
    component: () => import('./views/ProfileView.vue'),
    props: route => ({ redirectTo: route.query.return_to ?? 'hear' }),
  },
  {
    name: 'hear',
    path: 'hear',
    component: () => import('./views/HearView.vue'),
  },
  {
    name: 'meetings',
    path: 'meetings',
    component: () => import('./views/MeetingsView.vue'),
    beforeEnter: requireMeetingRecorder,
  },
  {
    name: 'download',
    path: 'downloads',
    component: () => import('./views/DownloadView.vue'),
  },
  {
    name: 'invite',
    path: 'invite',
    alias: ['invite_members', 'invite_collaborators'],
    component: () => import('./views/InviteView.vue'),
    props: () => ({ redirectTo: 'profile' }),
  },
];
